import { useKeyboardShortcuts } from '../../../hooks/useKeyboardShortcuts';

interface Props {
  sentenceCount: number;
  onReveal: () => void;
}

export default function RecallPhase({ sentenceCount, onReveal }: Props) {
  // Enter 或 Space 触发查看要点
  useKeyboardShortcuts({
    shortcuts: {
      'enter': onReveal,
      ' ': onReveal,  // Space 键
    },
  });

  return (
    <div className="topic-recall-content">
      <div className="topic-dictation-recall-box">
        <p className="topic-dictation-count">
          本话题有 <strong>{sentenceCount}</strong> 个要点
        </p>
        <p className="topic-dictation-recall-hint">先在脑中回忆，再点击查看</p>
      </div>
      <button
        type="button"
        className="topic-recall-reveal-btn"
        onClick={onReveal}
      >
        查看要点 → (Enter)
      </button>
    </div>
  );
}
